<template lang="pug">
.content-center
  .modal-header.justify-content-start.align-items-center.p-2.border-bottom-0.page-title.mobile-close(@click="$helpers.redirect('')" )
    .arrow-left
      i.fas.fa-chevron-left
    .modal-title.text-capitalize.pl-3 home
  .subtitle-wrap
    .bg-subtitle
      .page-subtitle about us
  .page-wrap02.page-about
    .bg-about
      .about-content
        .text-white.mb-2.text-uppercase.font-weight-bold.text-big LIVE22 OFFICIAL TEAM
        .text-white.mb-4.text-smaller
        .text-success.mb-2.font-weight-bold.text-big About Us
        .about-detail
          p.text-white.mb-3
            | Welcome to Live22 Cash, where we understand all your needs and wants. Live22 Cash is here to provide you with an extraordinary slot gaming experience that you will love. We create lasting connections with our players because we believe that what we do can weave a fabric of positive relationships and experiences that encompass our slots and the world at large. All we want is to create the best and most enjoyable atmosphere for all our players, no matter where in the world they may be.
          p.text-success Gamification
          p.text-white.mb-3
            ul
              li 3x complimentary entry tickets (upon successful member registration) to participate in our exciting tournament!
              li Complete missions of our special in-app events to obtain additional bonus rewards
              li New and attractive monthly in-app events
          p.text-success Instant Deposit & Withdrawal 
          p.text-white.mb-3
            ul
              li Direct in-app deposit and withdrawal
              li GUARANTEED payment within 1 MINUTE!
              li Your transactions are always fully secured
          p.text-success We Give Generously
          p.text-white.mb-3
            ul
              li HIGH Return-To-Player (RTP)
              li Exclusive Live Stream Bonus
              li Nonstop value-add member events & attractive promotions
  footerInfo
</template>
<script>
import footerInfo from "@/views/default/_footer.vue";
export default {
  components:{
    footerInfo
  }
}
</script>
<style lang="scss" scoped>

</style>